<template>
  <Container v-if="!pending && data" class="bg-surface-default-low px-16 pt-24">
    <div class="block gap-64 md:flex">
      <div class="sticky top-[168px] hidden max-w-[50%] self-start md:block">
        <DesignPickers :design-pickers="data.designPickers" />
      </div>

      <div>
        <div class="mb-32 space-y-32">
          <div class="space-y-8">
            <h2 class="text-static-default-hi heading-1">
              {{ i18n(translations.title) }}
            </h2>
            <div class="text-static-default-hi body-2">
              {{ i18n(translations.subtitle) }}
            </div>
          </div>

          <DesignPickers
            class="md:hidden"
            :design-pickers="data.designPickers"
          />

          <ReassuranceItems />
        </div>
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import Container from '~/scopes/product/components/Container/Container.vue'

import translations from './GiftCards.translations'
import DesignPickers from './components/DesignPickers/DesignPickers.vue'
import ReassuranceItems from './components/ReassuranceItems/ReassuranceItems.vue'

const i18n = useI18n()
const $httpFetch = useHttpFetch()

const { data, pending } = await useAsyncData(() =>
  $httpFetch('/api/gift-cards/v1/product-page/giftcard', {
    method: 'GET',
  }),
)
</script>
